<if(input.url)>
    <a href=input.url data-track=input.tracking class="str-contact-link" aria-label=input.label>
        <ebay-text-messaging-64-icon/>
        <span class="str-contact-link__text">${input.label}</span>
    </a>
</if>
